// ClikMeet's door, for whoever keeps it — the host and the colleagues ClikWork signed in (CR-20260926-001 F6, U3). One
// list, drawn the same in the call's Participants and on the lobby: "Waiting (n)", each person with Refuse and Admit,
// and Admit all. The answers are the studio's (lib/store.js decideKnock): two presses, or two keepers, admit once.
import { door } from "./api.js";
import { h, initials, toast } from "./dom.js";

export const DOOR_POLL_MS = 3000;

// A door that asks every few seconds and calls onChange(knocks) with who is waiting. stop() ends the asking.
export function watchDoor(code, onChange) {
  let knocks = [], timer = null, stopped = false;
  async function poll() {
    try { ({ knocks } = await door(code, "list")); } catch { return; }
    if (!stopped) onChange(knocks);
  }
  async function answer(k, action) {
    try { await door(code, action, k.id); } catch (err) { toast(err.message || "That did not go through — try again."); }
    await poll();
  }
  async function admitAll() {
    for (const k of [...knocks]) {
      try { await door(code, "admit", k.id); } catch (err) {
        // A full room refuses the rest the same way: say it once and stop, not once per person (re-audit N3).
        toast(err.message || `${k.name} could not be let in — try again.`, 4000, "door");
        // Stop on a full room or a meeting that closed; a knock that went quiet ("gone") is skipped, not a reason to
        // leave everyone after it at the door (re-audit of 53e3d35e).
        if (["too_many", "cancelled", "ended"].includes(err.data?.code)) break;
      }
    }
    await poll();
  }
  poll();
  timer = setInterval(poll, DOOR_POLL_MS);
  return { answer, admitAll, poll, get knocks() { return knocks; }, stop() { stopped = true; clearInterval(timer); } };
}

// The list itself, into `box` (a <section class="waitlist">): hidden when nobody is waiting.
// A poll that finds the same people waiting leaves the list as it is: rebuilding it every 3 s swapped the Admit and Refuse
// buttons under the host's finger (a press mid-repaint went nowhere; the U2/U3/U7 e2e check caught a detached Admit).
const PAINTED = new WeakMap();
export function paintWaitlist(box, knocks, { answer, admitAll }) {
  const who = knocks.map((k) => `${k.id}\u0001${k.name}`).join("\u0002");
  if (PAINTED.get(box) === who && box.isConnected && (knocks.length ? box.childElementCount > 0 : box.hidden)) return;
  PAINTED.set(box, who);
  box.hidden = !knocks.length;
  if (!knocks.length) { box.replaceChildren(); return; }
  box.replaceChildren(
    h("header", {}, h("h4", { text: `Waiting (${knocks.length})` }),
      knocks.length > 1 ? h("button", { class: "btn door-admit-all", type: "button", text: "Admit all", onclick: () => admitAll() }) : null),
    h("ul", { class: "plist" }, ...knocks.map((k) => h("li", { class: "waiting-row" },
      h("div", { class: "avatar", text: initials(k.name) }),
      h("div", { class: "who" }, h("b", { text: k.name }), h("small", { text: "Asking to join" })),
      h("button", { class: "act", type: "button", text: "Refuse", onclick: () => answer(k, "refuse") }),
      h("button", { class: "btn door-admit", type: "button", text: "Admit", onclick: () => answer(k, "admit") })))));
}
